export default {"src":"/_next/static/media/threelines.3eb185e1.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};